import defaultRole from "constant/config.role";
import { contact } from "./agent";

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const Members = [
    {
        id: `driver`,
        title: `Drivers`,
        type: `item`,
        url: `${defaultRole.admin}/portal/drivers`,
        icon: `wheel`,
        breadcrumbs: false,
        parentId: "member_portal",
        activeItem:[`/${defaultRole.admin}/portal/drivers`,  `/${defaultRole.admin}/portal/driver/view`, `/${defaultRole.admin}/portal/driver/edit` ]

    },
    {
        id: `fleet_operators`,
        title: `Fleet Operators`,
        type: `item`,
        url: `${defaultRole.admin}/portal/fleetoperators`,
        icon: `group`,
        breadcrumbs: false,
        parentId: "member_portal",
        activeItem:[`/${defaultRole.admin}/portal/fleetoperators`,`/${defaultRole.admin}/portal/fleetoperator/view`, `/${defaultRole.admin}/portal/fleetoperator/edit`]
    },
    {
        id: `Vehicle_owners_reg`,
        title: `Vehicle Owners / Reg`,
        type: `item`,
        url: `${defaultRole.admin}/portal/vehicleowners`,
        icon: `directionsCar`,
        breadcrumbs: false,
        parentId: "member_portal",
        activeItem:[`/${defaultRole.admin}/portal/vehicleowners`,`/${defaultRole.admin}/portal/vehicleowner/view`, `/${defaultRole.admin}/portal/vehicleowner/edit`]
    },
    {
        id: `serviceproviders`,
        title: `Service Providers`,
        type: `item`,
        url: `${defaultRole.admin}/portal/serviceproviders`,
        icon: `serviceprovider`,
        breadcrumbs: false,
        parentId: "member_portal",
        activeItem:[`/${defaultRole.admin}/portal/serviceproviders`,`/${defaultRole.admin}/portal/serviceprovider/view`,`/${defaultRole.admin}/portal/serviceprovider/edit`]
    },
]
const MemberPortal = [
    {
        id: `default`,
        title: `Dashboard`,
        type: `item`,
        url: `${defaultRole.admin}/portal/dashboard`,
        icon: `gridView`,
        breadcrumbs: false,
        parentId: "member_portal"
    },
    {
        id: `service_agents`,
        title: `Service Representatives`,
        type: `item`,
        url: `${defaultRole.admin}/portal/serviceagents`,
        icon: `person`,
        breadcrumbs: false,
        parentId: "member_portal",
        activeItem:[`/${defaultRole.admin}/portal/serviceagents`, `/${defaultRole.admin}/portal/serviceagent/view`,`/${defaultRole.admin}/portal/serviceagent/edit`]
    },
];

const AgentMemberPortal = [
    {
        id: `default`,
        title: `Dashboard`,
        type: `item`,
        url: `${defaultRole.admin}/portal/dashboard`,
        icon: `gridView`,
        breadcrumbs: false,
        parentId: "member_portal"
    },
];

const MyBusiness = [
    {
        id: `vehicle`,
        title: `Vehicles`,
        type: `item`,
        url: `${defaultRole.admin}/mybusiness/vehiclelist`,
        icon: `directionsCar`,
        breadcrumbs: false,
        parentId: "my_business",
        activeItem:[`/${defaultRole.admin}/mybusiness/vehiclelist`, `/${defaultRole.admin}/mybusiness/vehicle/edit`, `/${defaultRole.admin}/mybusiness/vehicle/view`]
    },
    {
        id: `vehiclepermits`,
        title: `Vehicle Permits`,
        type: `item`,
        url: `${defaultRole.admin}/mybusiness/vehiclepermits`,
        icon: `vehiclepermit`,
        breadcrumbs: false,
        parentId: "my_business",
        activeItem:[`/${defaultRole.admin}/mybusiness/vehiclepermits`,`/${defaultRole.admin}/mybusiness/vehiclepermit/view`,`/${defaultRole.admin}/mybusiness/vehiclepermit/edit`]
    },
    {
        id: `Telematics`,
        title: `Telematics`,
        type: `item`,
        url: `${defaultRole.admin}/mybusiness/telematics`,
        icon: `dongle`,
        breadcrumbs: false,
        parentId: "my_business",
        activeItem:[`/${defaultRole.admin}/mybusiness/telematics`,`/${defaultRole.admin}/mybusiness/telematics/view`,`/${defaultRole.admin}/mybusiness/telematics/edit`]
    },
];

const HelpSupport = [
    {
        id: `Chat`,
        title: `Chat`,
        type: `item`,
        url: `${defaultRole.admin}/help/chat`,
        icon: `chat`,
        breadcrumbs: false,
        parentId: "HelpSupport"
    },
    {
        id: `Mail`,
        title: `Mail`,
        type: `item`,
        url:`${defaultRole.admin}/help/mail`,
        icon: `draft`,
        breadcrumbs: false,
        parentId: "HelpSupport"
    },
        ]

export const admin = {
    id: `dashboard`,
    title: `Dashboard`,
    type: `group`,
    children: [
        {
            id: `default`,
            title: `Dashboard`,
            type: `item`,
            url: `${process.env.REACT_APP_DC_URL}profile/services`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `services`,
            title: `Services`,
            type: `item`,
            url: `${process.env.REACT_APP_FHT_URL}login`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `member_portal`,
            title: `Member Portal`,
            type: `collapse`,
            url: `${defaultRole.admin}/portal/dashboard`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [...MemberPortal, ...Members]
        },
        {
            id: `my_business`,
            title: `My Business`,
            type: `collapse`,
            url: ``,
            icon: `gridView`,
            breadcrumbs: false,
            children: MyBusiness
        },
        {
            id: `reports`,
            title: `Reports`,
            type: `collapse`,
            url: `${defaultRole.admin}/reports/member`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [
                {
                    id: `member`,
                    title: `Members`,
                    type: `item`,
                    url: `${defaultRole.admin}/reports/member`,
                    icon: `gridView`,
                    parentId: "reports",
                    breadcrumbs: false,
                },
                {
                    id: `vehicle`,
                    title: `Vehicles`,
                    type: `item`,
                    url: `${defaultRole.admin}/reports/vehicle`,
                    icon: `directionsCar`,
                    parentId: "reports",
                    breadcrumbs: false,
                    // activeItem:[`/${defaultRole.admin}/vehicles`, `/${defaultRole.admin}/viewvehicle`, `/${defaultRole.admin}/editvehicle`]
                },
                // {
                //     id: `service_agents`,
                //     title: `Service Representatives`,
                //     type: `item`,
                //     url: `${defaultRole.admin}/reports/serviceagents`,
                //     icon: `person`,
                //     breadcrumbs: false,
                //     parentId: "reports",
                //     // activeItem:[`/${defaultRole.admin}/serviceagents`, `/${defaultRole.admin}/viewserviceagent`,`/${defaultRole.admin}/editserviceagent`]
                // },
                {
                    id: `incidents`,
                    title: `Incidents`,
                    type: `item`,
                    url: `${defaultRole.admin}/reports/incidents`,
                    icon: `wheel`,
                    breadcrumbs: false,
                    parentId: "reports",
                    // activeItem:[`/${defaultRole.admin}/drivers`,  `/${defaultRole.admin}/viewdriver`, `/${defaultRole.admin}/editdriver` ]
        
                },
                {
                    id: `legal_tickets`,
                    title: `Legal Tickets`,
                    type: `item`,
                    url: `${defaultRole.admin}/reports/legaltickets`,
                    icon: `group`,
                    breadcrumbs: false,
                    parentId: "reports",
                },
            ]
        },
        {
            id: `siteadministration`,
            title: `Site Administration`,
            type: `collapse`,
            url: `${defaultRole.admin}/siteadministration/adminusers`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [
                {
                    id: `adminusers`,
                    title: `Admin Users`,
                    type: `item`,
                    url: `${defaultRole.admin}/siteadministration/adminusers`,
                    icon: `gridView`,
                    breadcrumbs: false,
                    parentId: "siteadministration",
                    activeItem:[`/${defaultRole.admin}/siteadministration/adminusers`, `/${defaultRole.admin}/siteadministration/viewadminuser`, `/${defaultRole.admin}/siteadministration/editadminuser`]
                },
                {
                    id: `documenttemplate`,
                    title: `Document Template`,
                    type: `item`,
                    url: `${defaultRole.admin}/siteadministration/documenttemplatelist`,
                    icon: `directionsCar`,
                    breadcrumbs: false,
                    parentId: "siteadministration",                                                                                                                                                          
                    activeItem:[`/${defaultRole.admin}/siteadministration/documenttemplatelist`, `/${defaultRole.admin}/siteadministration/documenttemplate/create`, `/${defaultRole.admin}/siteadministration/documenttemplate/view`, `/${defaultRole.admin}/siteadministration/documenttemplate/edit`]
                },
            ]
        },
        // {
        //     id: `documents-reportts`,
        //     title: `Documents`,
        //     type: `item`,
        //     url: `${defaultRole.admin}/documents/documentsreports`,
        //     icon: `vehicleowner`,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: `Documents-report`,
        //             title: `Documents`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/documents/documentsreports`,
        //             icon: `directionsCar`,
        //             breadcrumbs: false,
        //             parentId: "documents-reportts",
        //             // activeItem:[`/${defaultRole.admin}/vehicleowners`,`/${defaultRole.admin}/viewvehicleowner`, `/${defaultRole.admin}/editvehicleowner`]
        //         },
        //     ]
        // },
        {
            id: `HelpSupport`,
            title: `Help & Support`,
            type: `item`,
            url: `${defaultRole.admin}help/chat`,
            icon: `vehicleowner`,
            breadcrumbs: false,
            children: HelpSupport
        },
    ]
};

export const Employee = {
    id: `dashboard`,
    title: `Dashboard`,
    type: `group`,
    children: [
        {
            id: `default`,
            title: `Dashboard`,
            type: `item`,
            url: `${process.env.REACT_APP_DC_URL}profile/services`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `services`,
            title: `Services`,
            type: `item`,
            url: `${process.env.REACT_APP_FHT_URL}login`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `member_portal`,
            title: `Member Portal`,
            type: `collapse`,
            url: `${defaultRole.admin}/portal/dashboard`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [...MemberPortal, ...Members]
        },
        {
            id: `my_business`,
            title: `My Business`,
            type: `collapse`,
            url: ``,
            icon: `gridView`,
            breadcrumbs: false,
            children: MyBusiness
        },
        // {
        //     id: `reports`,
        //     title: `Reports`,
        //     type: `collapse`,
        //     url: `${defaultRole.admin}/reports/member`,
        //     icon: `gridView`,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: `member`,
        //             title: `Members`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/reports/member`,
        //             icon: `gridView`,
        //             parentId: "reports",
        //             breadcrumbs: false,
        //         },
        //         {
        //             id: `vehicle`,
        //             title: `Vehicles`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/reports/vehicle`,
        //             icon: `directionsCar`,
        //             parentId: "reports",
        //             breadcrumbs: false,
        //             // activeItem:[`/${defaultRole.admin}/vehicles`, `/${defaultRole.admin}/viewvehicle`, `/${defaultRole.admin}/editvehicle`]
        //         },
        //         // {
        //         //     id: `service_agents`,
        //         //     title: `Service Representatives`,
        //         //     type: `item`,
        //         //     url: `${defaultRole.admin}/reports/serviceagents`,
        //         //     icon: `person`,
        //         //     breadcrumbs: false,
        //         //     parentId: "reports",
        //         //     // activeItem:[`/${defaultRole.admin}/serviceagents`, `/${defaultRole.admin}/viewserviceagent`,`/${defaultRole.admin}/editserviceagent`]
        //         // },
        //         {
        //             id: `incidents`,
        //             title: `Incidents`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/reports/incidents`,
        //             icon: `wheel`,
        //             breadcrumbs: false,
        //             parentId: "reports",
        //             // activeItem:[`/${defaultRole.admin}/drivers`,  `/${defaultRole.admin}/viewdriver`, `/${defaultRole.admin}/editdriver` ]
        
        //         },
        //         {
        //             id: `legal_tickets`,
        //             title: `Legal Tickets`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/reports/legaltickets`,
        //             icon: `group`,
        //             breadcrumbs: false,
        //             parentId: "reports",
        //             // activeItem:[`/${defaultRole.admin}/fleetoperators`,`/${defaultRole.admin}/viewfleetoperators`, `/${defaultRole.admin}/editfleetoperators`]
        //         },
        //     ]
        // },
        // {
        //     id: `siteadministration`,
        //     title: `Site Administration`,
        //     type: `collapse`,
        //     url: `${defaultRole.admin}/siteadministration/adminusers`,
        //     icon: `gridView`,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: `adminusers`,
        //             title: `Admin Users`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/siteadministration/adminusers`,
        //             icon: `gridView`,
        //             breadcrumbs: false,
        //             parentId: "siteadministration",
        //             activeItem:[`/${defaultRole.admin}/siteadministration/adminusers`, `/${defaultRole.admin}/siteadministration/viewadminuser`, `/${defaultRole.admin}/siteadministration/editadminuser`]
        //         },
        //         {
        //             id: `documenttemplate`,
        //             title: `Document Template`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/siteadministration/documenttemplatelist`,
        //             icon: `directionsCar`,
        //             breadcrumbs: false,
        //             parentId: "siteadministration",                                                                                                                                                          
        //             activeItem:[`/${defaultRole.admin}/siteadministration/documenttemplatelist`, `/${defaultRole.admin}/siteadministration/documenttemplate/create`, `/${defaultRole.admin}/siteadministration/documenttemplate/view`, `/${defaultRole.admin}/siteadministration/documenttemplate/edit`]
        //         },
        //     ]
        // },
        // {
        //     id: `documents-reportts`,
        //     title: `Documents`,
        //     type: `item`,
        //     url: `${defaultRole.admin}/documents/documentsreports`,
        //     icon: `vehicleowner`,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: `Documents-report`,
        //             title: `Documents`,
        //             type: `item`,
        //             url: `${defaultRole.admin}/documents/documentsreports`,
        //             icon: `directionsCar`,
        //             breadcrumbs: false,
        //             parentId: "documents-reportts",
        //             // activeItem:[`/${defaultRole.admin}/vehicleowners`,`/${defaultRole.admin}/viewvehicleowner`, `/${defaultRole.admin}/editvehicleowner`]
        //         },
        //     ]
        // },
        // {
        //     id: `HelpSupport`,
        //     title: `Help & Support`,
        //     type: `item`,
        //     url: `${defaultRole.admin}help/chat`,
        //     icon: `vehicleowner`,
        //     breadcrumbs: false,
        //     children: HelpSupport
        // },
    ]
};


export const ServiceRep = {
    id: `dashboard`,
    title: `Dashboard`,
    type: `group`,
    children: [
        {
            id: `default`,
            title: `Dashboard`,
            type: `item`,
            url: `${process.env.REACT_APP_DC_URL}profile/services`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `services`,
            title: `Services`,
            type: `item`,
            url: `${process.env.REACT_APP_FHT_URL}login`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `member_portal`,
            title: `Member Portal`,
            type: `collapse`,
            url: `${defaultRole.admin}/portal/dashboard`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [...AgentMemberPortal, ...Members]
        },
        {
            id: `my_business`,
            title: `My Business`,
            type: `collapse`,
            url: ``,
            icon: `gridView`,
            breadcrumbs: false,
            children: MyBusiness
        },
        {
            id: `HelpSupport`,
            title: `Help & Support`,
            type: `item`,
            url: `${defaultRole.admin}/help/chat`,
            icon: `vehicleowner`,
            breadcrumbs: false,
            children: [...HelpSupport, contact]
        },
    ]
};
